import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { createStructuredSelector } from 'reselect';

import RightForm from './RightForm';

import { signup } from '~redux/profile/actions';

import { compose } from '~utils';

const actions = { onSubmit: signup };

const selectors = createStructuredSelector({});

const reduxConnect = connect(
  selectors,
  actions,
);

const formConect = reduxForm({
  form: 'signupInvestorForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
});

export default compose(
  reduxConnect,
  formConect,
)(RightForm);
